<template>
  <v-dialog v-model="editDialog" persistent width="1024">
    <template v-slot:activator="{ on, attrs }">
      <v-btn color="primary" dark class="mx-4" v-bind="attrs" v-on="on">
        Add IPaaS Problem
      </v-btn>
    </template>
    <v-card>
      <v-card-title class="text-h5 accent lighten-2">
        {{ formTitle }}
      </v-card-title>

      <v-card-text>
        <v-container>
          <v-row>
            <v-col cols="12" sm="6" md="6" class="text-center">
              <v-text-field v-model="editedVersion.ipaas_problem_ref" label="Name" />
              <v-select
                v-model="editedVersion.occurs_from"
                :items="software"
                item-text="ipaas_version"
                item-value="ipaas_software_id"
                label="Occurs From"
              />
              <v-switch
                v-model="editedVersion.fixed"
                label="Fixed"
                true-value="y"
                false-value="n"
              />
            </v-col>
            <v-col cols="12" sm="6" md="6" class="text-center">
              <v-select
                v-model="editedVersion.fixed_in"
                :items="software"
                item-text="ipaas_version"
                item-value="ipaas_software_id"
                label="Fixed In"
              />
              <v-switch
                v-model="editedVersion.workaround_available"
                label="Workaround Available"
                true-value="y"
                false-value="n"
              />
              <v-switch
                v-model="editedVersion.workaround_in_script"
                label="Workaround In Script"
                true-value="y"
                false-value="n"
              />
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>

      <v-divider />

      <v-card-actions>
        <v-spacer />
        <v-btn text @click="close"> CANCEL </v-btn>
        <v-btn color="accent" @click="save"> CONFIRM </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import axios from 'axios'
  import { authHeader } from '@/util/helpers'
  import getEnv from '@/util/env'
  const host = getEnv('VUE_APP_API_HOST')
  export default {
    name: 'IpaasProblemDialog',
    data () {
      return {
        editDialog: false,
        editedIndex: -1,
        editedVersion: {
          ipaas_problem_ref: '',
          fixed: 'n',
          workaround_available: 'n',
          workaround_in_script: 'n',
          occurs_from: 1,
          fixed_in: null
        },
        defaultVersion: {
          ipaas_problem_ref: '',
          fixed: 'n',
          workaround_available: 'n',
          workaround_in_script: 'n',
          occurs_from: 1,
          fixed_in: null
        },
      }
    },
    computed: {
      formTitle () {
        return this.editedIndex === -1 ? 'New IPaaS Problem' : 'Edit IPaaS Problem'
      },
      software () {
        let soft = [{
          ipaas_software_id: null,
          ipaas_version: 'None'
        }]
        
        return soft.concat(this.$store.getters['software/ipaas'])
      },
      problems () {
        return this.$store.getters['software/ipaas_problems']
      }
    },
    watch: {
      'editedVersion.fixed': {
        handler () {
          this.check_fixed()
        },
        deep: true
      },
      'editedVersion.fixed_in': {
        handler () {
          this.check_fixed_in()
        },
        deep: true
      } 
    },
    methods: {
      check_fixed: function () {
        if (this.editedVersion.fixed === 'n' && this.editedVersion.fixed_in > 0) {
          this.editedVersion.fixed_in = null
        } else if (this.editedVersion.fixed === 'y' && this.editedVersion.fixed_in === null) {
          this.editedVersion.fixed_in = 1
        }
      },
      check_fixed_in: function () {
        if (this.editedVersion.fixed === 'n' && this.editedVersion.fixed_in > 0) {
          this.editedVersion.fixed = 'y'
        } else if (this.editedVersion.fixed === 'y' && this.editedVersion.fixed_in === null) {
          this.editedVersion.fixed = 'n'
        }
      },
      editVersion: function (problem) {
        this.editedIndex = this.problems.indexOf(problem)
        this.editedVersion = Object.assign({}, problem)

        this.editDialog = true
      },
      close () {
        this.editDialog = false
        this.$nextTick(() => {
          this.editedVersion = Object.assign({}, this.defaultVersion)
          this.editedIndex = -1
        })
      },
      save: function() {
        delete this.editedVersion.fixed_in_ipaas_software
        if (this.editedIndex > -1) {
          this.updateVersion()
        } else {
          this.createVersion()
        }
        this.close()
      },
      updateVersion: function () {
        axios
          .put(
            `${host}/v2/ipaas_problems/${this.editedVersion.ipaas_problem_id}`,
            this.editedVersion,
            {
              headers: authHeader(),
            }
          )
          .then(() => {
            this.$snackbar.showMessage({ content: 'IPaaS problem has been updated', color: 'success', timeout: 5000 })
            this.$store.dispatch('software/load')
          })
          .catch((err) => {
            this.$errordialog.showMessage({ content: err.response.data.message, color: 'error', title: 'Oops! Something went wrong.' })
          })
      },
      createVersion: function () {
        axios
          .post(
            `${host}/v2/ipaas_problems/new`,
            this.editedVersion,
            {
              headers: authHeader(),
            }
          )
          .then(() => {
            this.$snackbar.showMessage({ content: 'IPaaS problem has been created', color: 'success', timeout: 5000 })
            this.$store.dispatch('software/load')
          })
          .catch((err) => {
            this.$errordialog.showMessage({ content: err.response.data.message, color: 'error', title: 'Oops! Something went wrong.' })
          })
      }
    }
  }
</script>